import React, {useEffect, useState} from 'react';
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullJson,
    checkNullStr,
    createTimeout,
    deepObjectComparison,
    focusFormIdElement,
    formatDateToIoString,
    getCurrUrlParamValue,
    getDefStr,
    getJsonValue,
    isBoolTrue,
    isJsonValueTrue,
    sanitizeMobileText
} from "../../common/fusion-ui/utils/ReactUtils";
import {sendAdminRequest} from "../utils/AdminUtils";
import {printError, printLog,} from "../../common/CommonUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {useNavigate} from "react-router-dom";
import {AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, ShowViewType} from "../config/AdminConfig";
import {Avatar, GridBox, Select} from "../../common/fusion-ui";
import {CssVariant, FsVarVariant, IconClass, Messages, Patterns} from "../../common/fusion-ui/config/FusionConfig";
import {ThemedIconButton, ThemedInput} from "../../common/components";
import {CscSelect, FormPageRoot, TimezoneSelect} from "../components";
import {AnimationType, EasingType, FramerAnimator} from "../../common/fusion-ui/animation/FramerAnimator";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {INPUT_FILE_MAX_SIZE, UnderMaintenance, UnderMaintenanceMsg} from "../../common/CommonConfig";

const Member__AddEditFormPage = React.memo(({
                                                updateOnly,
                                                cloneMode = false,
                                                open,
                                                onHide,
                                                recordId,
                                                showAs = ShowViewType.PAGE,
                                                onSuccess,
                                            }) => {
    const TAG = "Member__AddEditFormPage";

    const moduleName = AdminModules.Members;
    const mf = AdminModuleFieldsData[moduleName];

    const theme = useTheme();
    const navigate = useNavigate();
    const {showToast, changeToastVariant} = useToast();
    const {isOnline, internetCheckingMsg} = useInternetStatus();
    // const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();

    const animator = new FramerAnimator();

    const NAME_PREFIXES = ['Dr.', 'Prof.', 'Mr.', 'Mrs.', 'Ms.'];
    const USER_TYPES = ['User', 'Admin'];
    const GENDERS = ['Male', 'Female'];

    const FOCUS_DELAY = 2000;
    const SECTIONS = {
        basicDetails: "Basic Details",
        additionalDetails: "Additional Details",
    };

    const Fields = {
        updateRecordId: 'updateRecordId',

        isUpdateFormDataFetched: 'isUpdateFormDataFetched',

        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',

        companies: 'companies',
        showCompaniesLoading: 'showCompaniesLoading',
        isCompDataFetched: 'isCompDataFetched',

        currCompGroups: 'currCompGroups',
        showCurrCompGroupsLoading: 'showCurrCompGroupsLoading',
        isCurrCompGroupsFetched: 'isCurrCompGroupsFetched',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});
    // const [formData, setFormData] = useState(Member__AddEditFormPage_FormData);
    const [formData, setFormData] = useState({});
    const [formFieldsMsgs, setFormFieldsMsgs] = useState({});
    const [sectionsExpanded, setSectionsExpanded] = useState({
        [SECTIONS.basicDetails]: true,
        // [SECTIONS.additionalDetails]: false,
    });
    const SectionRequiredFields = {
        //Company Name
        // Asign Group
        // Prefix
        // First Name
        // Last Name
        // User Name
        // Password
        // User Type :
        // Gender :
        // Mobile No. 1
        // Email ID 1
        // Country
        // State :
        // City :
        // Speciality 1
        [SECTIONS.basicDetails]: [mf.companyId, mf.memberPrefix, mf.firstName, mf.lastName, mf.username, mf.vokUserPassword, mf.memberUser, mf.gender, mf.memberMobile1, mf.memberEmail1, mf.countryId, mf.timezoneId, mf.memberSpeciality1],
        [SECTIONS.additionalDetails]: [],
    };

    useEffect(() => {
        if (!checkNullStr(getField(Fields.panelMsg)) && !isUpdateMode()) {
            updateField(Fields.isDataLoading, false);
            updateField(Fields.isDataFound, true);
        }

        log('useEffect.showAs:', showAs, 'recordId:', recordId, 'updateOnly:', isUpdateMode, 'cloneMode:', isCloneMode());
        if (showAs == ShowViewType.PAGE) {
            if (isUpdateMode() || isCloneMode()) {
                const id = getCurrUrlParamValue('id');
                log('useEffect.showAs:', showAs, 'id:', id);
                fetchEditModeData(id);
            }
        } else {
            if (checkNullStr(recordId) && (isUpdateMode() || isCloneMode())) {
                fetchEditModeData(recordId, false);
            }
        }
        fetchCompanies();
    }, [recordId, showAs, updateOnly, cloneMode]);

    return (<>
            <FormPageRoot
                tag={TAG}
                moduleName={moduleName}
                updateOnly={isUpdateMode()}
                isDataLoading={getField(Fields.isDataLoading)}
                isDataFound={getField(Fields.isDataFound)}
                dataLoadingMsg={getField(Fields.dataLoadingMsg)}
                addPageTitle={getTabTitle()}
                open={open}
                onHide={() => {
                    if (onHide) onHide();
                    clearPanelData();
                }}
                showAs={showAs}
                md={12}
                drawerWidth={'75%'}
                panelMsg={getField(Fields.panelMsg)}
                panelMsgColor={getField(Fields.panelMsgColor)}
                isSubmitDisabled={isFieldTrue(Fields.submitBtn_disabled)}
                isSubmitLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                onSubmit={handleSubmit}
                onPageRefresh={() => fetchEditModeData(getField(Fields.updateRecordId), false)}
            >
                <div className={''}>
                    {/*basicDetails section*/}
                    <ExpandableView title={SECTIONS.basicDetails}
                                    retainInDOM={true}
                                    expanded={sectionsExpanded[SECTIONS.basicDetails]}
                                    onToggle={(exp) => handleSectionExpCollapse(SECTIONS.basicDetails, exp)}>
                        <GridBox className={'px-0'} sm={12} md={6} justifyAt={'start'}>
                            {/*left-section*/}
                            {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                <div>
                                    {/*company-select*/}
                                    <Select
                                        id={mf.companyId.column}
                                        wrapperClassName={`w-100`}
                                        className={`w-100 rounded-3 py-2`}
                                        innerWrapperClassName={'w-100'}
                                        labelClassName={'w-100 text-input-label'}
                                        variant={'primary'}
                                        justifyAt={'center'}
                                        labelColor={theme.text40}
                                        label={'Select a company'}
                                        placeholder={'Select a company'}
                                        wrap={'wrap'}
                                        textKey={'text'}
                                        idKey={'id'}
                                        required={true}
                                        options={getField(Fields.companies, [])}
                                        defOption={getFormField(mf.companyId)}
                                        showLoader={isFieldTrue(Fields.showCompaniesLoading)}
                                        disabled={isFieldTrue(Fields.showCompaniesLoading) || isFieldTrue(Fields.showCurrCompGroupsLoading)}
                                        showRefresh={true}
                                        onRefresh={() => fetchCompanies(false)}
                                        onChange={(e, text, value) => {
                                            // log('comp.Select.onChange::text:', text, "value:", value);
                                            updateFormField(mf.companyId, value);
                                            updateFormField(mf.companyName, text);

                                            fetchCurrCompanyGroups(value, text, false)
                                        }}
                                    />

                                    {/*assignGroupId-select*/}
                                    <Select
                                        id={mf.assignGroupId.column}
                                        wrapperClassName={`w-100 mt-3`}
                                        className={`w-100 rounded-3 py-2`}
                                        innerWrapperClassName={'w-100'}
                                        labelClassName={'w-100 text-input-label'}
                                        variant={'primary'}
                                        justifyAt={'center'}
                                        labelColor={theme.text40}
                                        labelAsPlaceholder={true}
                                        label={'Select a group to assign to'}
                                        wrap={'wrap'}
                                        textKey={'text'}
                                        idKey={'id'}
                                        required={checkNullArr(getField(Fields.currCompGroups))}
                                        options={getField(Fields.currCompGroups, [])}
                                        defOption={getFormField(mf.assignGroupId)}
                                        showLoader={isFieldTrue(Fields.showCurrCompGroupsLoading)}
                                        disabled={!checkNullStr(getFormField(mf.companyId)) || isFieldTrue(Fields.showCompaniesLoading) || isFieldTrue(Fields.showCurrCompGroupsLoading)}
                                        showRefresh={true}
                                        onRefresh={() => fetchCurrCompanyGroups(getFormField(mf.companyId), getFormField(mf.companyName), false)}
                                        onChange={(e, text, value) => {
                                            // log('assignGroupId.Select.onChange::text:', text, "value:", value);
                                            updateFormField(mf.assignGroupId, value);
                                            updateFormField(mf.assignGroupName, text);
                                        }}
                                    />

                                    {/*memberPrefix-select*/}
                                    <Select
                                        id={mf.memberPrefix.column}
                                        wrapperClassName={`w-100 mt-3`}
                                        className={`w-100 rounded-3 py-2`}
                                        innerWrapperClassName={'w-100'}
                                        labelClassName={'w-100 text-input-label'}
                                        variant={'primary'}
                                        justifyAt={'center'}
                                        labelColor={theme.text40}
                                        label={'Select a member prefix'}
                                        labelAsPlaceholder={true}
                                        wrap={'wrap'}
                                        textKey={'text'}
                                        idKey={'id'}
                                        required={true}
                                        options={NAME_PREFIXES.map(item => ({id: item, text: item}))}
                                        defOption={getFormField(mf.memberPrefix)}
                                        onChange={(e, text, value) => {
                                            // log('memberPrefix.Select.onChange::text:', text, "value:", value);
                                            updateFormField(mf.memberPrefix, value);
                                        }}
                                    />

                                    {/*firstName*/}
                                    <ThemedInput
                                        wrapperClassName={'mt-3'}
                                        className={''}
                                        label={mf.firstName.title}
                                        placeholder={mf.firstName.title}
                                        id={mf.firstName.column}
                                        value={getFormField(mf.firstName)}
                                        msg={getFormFieldMsg(mf.firstName)}
                                        required={true}
                                        type={'text'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.firstName, value);
                                            panelLog('');
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.firstName, '');
                                        }}
                                    />

                                    {/*lastName*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.lastName.title}
                                        placeholder={mf.lastName.title}
                                        id={mf.lastName.column}
                                        value={getFormField(mf.lastName)}
                                        msg={getFormFieldMsg(mf.lastName)}
                                        required={true}
                                        type={'text'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.lastName, value);
                                            panelLog('');
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.lastName, '');
                                        }}
                                    />

                                    {/*username*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.username.title}
                                        placeholder={mf.username.title}
                                        id={mf.username.column}
                                        value={getFormField(mf.username)}
                                        msg={getFormFieldMsg(mf.username)}
                                        required={true}
                                        type={'username'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.username, value);
                                            panelLog('');
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.username, '');
                                        }}
                                    />

                                    {/*vokUserPassword*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.vokUserPassword.titleAlt}
                                        placeholder={mf.vokUserPassword.titleAlt}
                                        id={mf.vokUserPassword.column}
                                        value={getFormField(mf.vokUserPassword)}
                                        msg={getFormFieldMsg(mf.vokUserPassword)}
                                        required={true}
                                        type={'password'}
                                        disabled={isUpdateMode()}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.vokUserPassword, value);
                                            panelLog('');
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.vokUserPassword, '');
                                        }}
                                    />

                                    {/*loginPin*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.loginPin.title}
                                        placeholder={mf.loginPin.title}
                                        id={mf.loginPin.column}
                                        value={getFormField(mf.loginPin)}
                                        msg={getFormFieldMsg(mf.loginPin)}
                                        type={'text'}
                                        pattern={Patterns.plainNumber}
                                        maxLength={6}
                                        showLimitLabel={true}
                                        iMsg={`A simpler alternative to password. Set a 6-digit login-pin for the user, simplifying their login process.`}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.loginPin, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberUser-select*/}
                                    <Select
                                        id={mf.memberUser.column}
                                        wrapperClassName={`w-100`}
                                        className={`w-100 rounded-3 py-2`}
                                        innerWrapperClassName={'w-100'}
                                        labelClassName={'w-100 text-input-label'}
                                        variant={'primary'}
                                        justifyAt={'center'}
                                        labelColor={theme.text40}
                                        label={`Select a ${mf.memberUser.title}`}
                                        labelAsPlaceholder={true}
                                        wrap={'wrap'}
                                        textKey={'text'}
                                        idKey={'id'}
                                        required={true}
                                        options={USER_TYPES.map(item => ({id: item, text: item}))}
                                        defOption={getFormField(mf.memberUser)}
                                        onChange={(e, text, value) => {
                                            // log('memberUser.Select.onChange::text:', text, "value:", value);
                                            updateFormField(mf.memberUser, value);
                                        }}
                                    />

                                    {/*memberDob*/}
                                    <ThemedInput
                                        wrapperClassName={'mt-3'}
                                        className={''}
                                        type={'date'}
                                        label={mf.memberDob.title}
                                        placeholder={mf.memberDob.title}
                                        id={mf.memberDob.column}
                                        value={getFormField(mf.memberDob)}
                                        msg={getFormFieldMsg(mf.memberDob)}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.memberDob, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberImage*/}
                                    <Avatar
                                        wrapperClassName={''}
                                        className={''}
                                        labelClassName={'pb-1'}
                                        justifyAt={'center'}
                                        alignAt={'start'}
                                        wrap={'wrap'}
                                        direction={'column'}
                                        label={mf.memberImage.titleAlt}
                                        labelColor={theme.text40}
                                        accept={'.jpg, .jpeg, .png'}
                                        editTooltip={`Edit (.jpg, .jpeg, .png)`}
                                        showEdit={true}
                                        showDelete={true}
                                        circular={false}
                                        showFullPreviewDialog={true}
                                        editSize={'21px'}
                                        size={'110px'}
                                        maxSize={INPUT_FILE_MAX_SIZE}
                                        onChange={(e, file, path, name, ext) => {
                                            log('Avatar.memberImage.onChange.name:', name, 'ext:', ext);
                                            updateFormField(mf.memberImage, file);
                                            updateFormField(mf.memberImageExt, ext);
                                        }}
                                        onDeleteClick={() => {
                                            updateFormField(mf.memberImage, null);
                                            updateFormField(mf.memberImageExt, null);
                                        }}
                                        onInvalidFormat={(e, name) => {
                                            toast(`Invalid file format. File must be jpg, jpeg or png`, CssVariant.danger);
                                        }}
                                        onSizeExceeded={() => {
                                            toast(`Max size exceeded: ${INPUT_FILE_MAX_SIZE}`, CssVariant.danger);
                                        }}>
                                        {getFormField(mf.memberImage)}
                                    </Avatar>
                                </div>
                            )}
                            {/*right-section*/}
                            {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                <div>
                                    {/*gender-select*/}
                                    <Select
                                        id={mf.gender.column}
                                        wrapperClassName={`w-100`}
                                        className={`w-100 rounded-3 py-2`}
                                        innerWrapperClassName={'w-100'}
                                        labelClassName={'w-100 text-input-label'}
                                        variant={'primary'}
                                        justifyAt={'center'}
                                        labelColor={theme.text40}
                                        label={mf.gender.title}
                                        labelAsPlaceholder={true}
                                        wrap={'wrap'}
                                        textKey={'text'}
                                        idKey={'id'}
                                        required={true}
                                        options={GENDERS.map(item => ({id: item, text: item}))}
                                        defOption={getFormField(mf.gender)}
                                        onChange={(e, text, value) => {
                                            // log('gender.Select.onChange::text:', text, "value:", value);
                                            updateFormField(mf.gender, value);
                                        }}
                                    />

                                    {/*memberMobile1*/}
                                    <ThemedInput
                                        wrapperClassName={'mt-3'}
                                        className={''}
                                        label={mf.memberMobile1.titleAlt}
                                        placeholder={mf.memberMobile1.titleAlt}
                                        id={mf.memberMobile1.column}
                                        value={getFormField(mf.memberMobile1)}
                                        msg={getFormFieldMsg(mf.memberMobile1)}
                                        required={true}
                                        type={'mobile'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 14) {
                                                updateFormField(mf.memberMobile1, sanitizeMobileText(value, 14));
                                            }
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.memberMobile1, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberMobile2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        type={'mobile'}
                                        label={mf.memberMobile2.title}
                                        placeholder={mf.memberMobile2.title}
                                        id={mf.memberMobile2.column}
                                        value={getFormField(mf.memberMobile2)}
                                        msg={getFormFieldMsg(mf.memberMobile2)}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 14) {
                                                updateFormField(mf.memberMobile2, sanitizeMobileText(value, 14));
                                            }
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.memberMobile2, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberEmail1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberEmail1.titleAlt}
                                        placeholder={mf.memberEmail1.titleAlt}
                                        id={mf.memberEmail1.column}
                                        value={getFormField(mf.memberEmail1)}
                                        msg={getFormFieldMsg(mf.memberEmail1)}
                                        required={true}
                                        type={'email'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 100) {
                                                if (checkNullStr(value)) {
                                                    let valid = Patterns.emailStandard.test(value);
                                                    updateFormField(mf.memberEmail1, value);
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.memberEmail1, valid ? '' : 'Invalid email!');
                                                }
                                            }
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberEmail2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberEmail2.titleAlt}
                                        placeholder={mf.memberEmail2.titleAlt}
                                        id={mf.memberEmail2.column}
                                        value={getFormField(mf.memberEmail2)}
                                        msg={getFormFieldMsg(mf.memberEmail2)}
                                        type={'email'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 100) {
                                                if (checkNullStr(value)) {
                                                    let valid = Patterns.emailStandard.test(value);
                                                    updateFormField(mf.memberEmail2, value);
                                                    if (checkNullStr(value)) updateFormFieldMsg(mf.memberEmail2, valid ? '' : 'Invalid email!');
                                                }
                                            }
                                            panelLog('');
                                        }}
                                    />

                                    {/*csc-select*/}
                                    <div className={''}>
                                        <CscSelect
                                            wrapperClassName={''}
                                            className={''}
                                            requiredCountry={true}
                                            fetchDefData={true}
                                            defCountryId={getFormField(mf.countryId)}
                                            defStateId={getFormField(mf.stateId)}
                                            defCityId={getFormField(mf.cityId)}
                                            itemWrapperStyle={{marginTop: '-0.28rem'}}
                                            cityWrapperStyle={{marginTop: '0.1rem'}}
                                            onCountryUpdate={(id, name, data) => {
                                                // log('onCountryUpdate.name:', name, 'id:', id);
                                                updateFormField(mf.countryName, name);
                                                updateFormField(mf.countryId, id);
                                                panelLog('');
                                            }}
                                            onStateUpdate={(id, name, data) => {
                                                // log('onStateUpdate.name:', name, 'id:', id);
                                                updateFormField(mf.stateName, name);
                                                updateFormField(mf.stateId, id);
                                                panelLog('');
                                            }}
                                            onCityUpdate={(id, name, data) => {
                                                // log('onCityUpdate.name:', name, 'id:', id);
                                                updateFormField(mf.cityName, name);
                                                updateFormField(mf.cityId, id);
                                                panelLog('');
                                            }}
                                        />
                                    </div>

                                    {/*timezone-select*/}
                                    <div style={{marginTop: '-0.35rem'}}>
                                        <TimezoneSelect
                                            wrapperClassName={''}
                                            className={''}
                                            required={true}
                                            defTsId={getFormField(mf.timezoneId)}
                                            onChange={(name, id) => {
                                                // log('ts.onChange.name:', name, 'id:', id);
                                                updateFormField(mf.timezoneName, name);
                                                updateFormField(mf.timezoneId, id);
                                                panelLog('');
                                            }}
                                        />
                                    </div>

                                    {/*memberSpeciality1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberSpeciality1.title}
                                        placeholder={mf.memberSpeciality1.title}
                                        id={mf.memberSpeciality1.column}
                                        value={getFormField(mf.memberSpeciality1)}
                                        msg={getFormFieldMsg(mf.memberSpeciality1)}
                                        type={'text'}
                                        pattern={Patterns.plainText}
                                        required={true}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberSpeciality1, value);
                                            if (checkNullStr(value)) updateFormFieldMsg(mf.memberSpeciality1, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberSpeciality2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberSpeciality2.title}
                                        placeholder={mf.memberSpeciality2.title}
                                        id={mf.memberSpeciality2.column}
                                        value={getFormField(mf.memberSpeciality2)}
                                        msg={getFormFieldMsg(mf.memberSpeciality2)}
                                        type={'text'}
                                        pattern={Patterns.plainText}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberSpeciality2, value);
                                            panelLog('');
                                        }}
                                    />
                                </div>
                            )}
                        </GridBox>
                    </ExpandableView>

                    {/*additionalDetails section*/}
                    <ExpandableView className={'mt-3'} title={SECTIONS.additionalDetails}
                                    retainInDOM={false}
                                    expanded={sectionsExpanded[SECTIONS.additionalDetails]}
                                    onToggle={(exp) => handleSectionExpCollapse(SECTIONS.additionalDetails, exp)}>
                        <GridBox className={'px-0'} sm={12} md={6} justifyAt={'start'}>
                            {/*left-section*/}
                            {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                <div className={'overflow-hidden'}>
                                    {/*memberOrganisation1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberOrganisation1.title}
                                        placeholder={mf.memberOrganisation1.title}
                                        id={mf.memberOrganisation1.column}
                                        value={getFormField(mf.memberOrganisation1)}
                                        msg={getFormFieldMsg(mf.memberOrganisation1)}
                                        type={'text'}
                                        pattern={Patterns.plainText}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberOrganisation1, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberDesignation1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberDesignation1.title}
                                        placeholder={mf.memberDesignation1.title}
                                        id={mf.memberDesignation1.column}
                                        value={getFormField(mf.memberDesignation1)}
                                        msg={getFormFieldMsg(mf.memberDesignation1)}
                                        type={'text'}
                                        pattern={Patterns.plainText}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberDesignation1, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberOrganisation2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberOrganisation2.title}
                                        placeholder={mf.memberOrganisation2.title}
                                        id={mf.memberOrganisation2.column}
                                        value={getFormField(mf.memberOrganisation2)}
                                        msg={getFormFieldMsg(mf.memberOrganisation2)}
                                        type={'text'}
                                        pattern={Patterns.plainText}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberOrganisation2, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberDesignation2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberDesignation2.title}
                                        placeholder={mf.memberDesignation2.title}
                                        id={mf.memberDesignation2.column}
                                        value={getFormField(mf.memberDesignation2)}
                                        msg={getFormFieldMsg(mf.memberDesignation2)}
                                        type={'text'}
                                        pattern={Patterns.plainText}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberDesignation2, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*highestEducation*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.highestEducation.title}
                                        placeholder={mf.highestEducation.title}
                                        id={mf.highestEducation.column}
                                        value={getFormField(mf.highestEducation)}
                                        msg={getFormFieldMsg(mf.highestEducation)}
                                        type={'text'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.highestEducation, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*interestArea1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.interestArea1.title}
                                        placeholder={mf.interestArea1.title}
                                        id={mf.interestArea1.column}
                                        value={getFormField(mf.interestArea1)}
                                        msg={getFormFieldMsg(mf.interestArea1)}
                                        type={'text'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.interestArea1, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*interestArea2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.interestArea2.title}
                                        placeholder={mf.interestArea2.title}
                                        id={mf.interestArea2.column}
                                        value={getFormField(mf.interestArea2)}
                                        msg={getFormFieldMsg(mf.interestArea2)}
                                        type={'text'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            updateFormField(mf.interestArea2, value);
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberBiography*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberBiography.title}
                                        placeholder={mf.memberBiography.title}
                                        id={mf.memberBiography.column}
                                        value={getFormField(mf.memberBiography)}
                                        msg={getFormFieldMsg(mf.memberBiography)}
                                        asTextArea={true}
                                        style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberBiography, value);
                                            updateFormFieldMsg(mf.memberBiography, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*homePhone*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.homePhone.title}
                                        placeholder={mf.homePhone.title}
                                        id={mf.homePhone.column}
                                        value={getFormField(mf.homePhone)}
                                        msg={getFormFieldMsg(mf.homePhone)}
                                        type={'mobile'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 14) {
                                                updateFormField(mf.homePhone, sanitizeMobileText(value, 14));
                                                if (checkNullStr(value)) updateFormFieldMsg(mf.homePhone, '');
                                            }
                                            panelLog('');
                                        }}
                                    />
                                </div>
                            )}

                            {/*right-section*/}
                            {animator.setAnimationType(AnimationType.SLIDE_RIGHT).setDuration(200).setEasing(EasingType.EASE_IN).renderChildren(
                                <div className={'overflow-hidden'}>
                                    {/*workPhone1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.workPhone1.title}
                                        placeholder={mf.workPhone1.title}
                                        id={mf.workPhone1.column}
                                        value={getFormField(mf.workPhone1)}
                                        msg={getFormFieldMsg(mf.workPhone1)}
                                        type={'mobile'}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 14) {
                                                updateFormField(mf.workPhone1, sanitizeMobileText(value, 14));
                                                if (checkNullStr(value)) updateFormFieldMsg(mf.workPhone1, '');
                                            }
                                            panelLog('');
                                        }}
                                    />

                                    {/*workPhone2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.workPhone2.title}
                                        placeholder={mf.workPhone2.title}
                                        id={mf.workPhone2.column}
                                        value={getFormField(mf.workPhone2)}
                                        msg={getFormFieldMsg(mf.workPhone2)}
                                        onChange={(e) => {
                                            const value = e.target.value + '';
                                            if (value.length <= 14) {
                                                updateFormField(mf.workPhone2, sanitizeMobileText(value, 14));
                                                if (checkNullStr(value)) updateFormFieldMsg(mf.workPhone2, '');
                                            }
                                            panelLog('');
                                        }}
                                    />

                                    {/*workAddress1*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.workAddress1.title}
                                        placeholder={mf.workAddress1.title}
                                        id={mf.workAddress1.column}
                                        value={getFormField(mf.workAddress1)}
                                        msg={getFormFieldMsg(mf.workAddress1)}
                                        asTextArea={true}
                                        style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.workAddress1, value);
                                            updateFormFieldMsg(mf.workAddress1, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*workAddress2*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.workAddress2.title}
                                        placeholder={mf.workAddress2.title}
                                        id={mf.workAddress2.column}
                                        value={getFormField(mf.workAddress2)}
                                        msg={getFormFieldMsg(mf.workAddress2)}
                                        asTextArea={true}
                                        style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.workAddress2, value);
                                            updateFormFieldMsg(mf.workAddress2, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*homeAddress*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.homeAddress.title}
                                        placeholder={mf.homeAddress.title}
                                        id={mf.homeAddress.column}
                                        value={getFormField(mf.homeAddress)}
                                        msg={getFormFieldMsg(mf.homeAddress)}
                                        asTextArea={true}
                                        style={{minHeight: '60px', height: '82.5px', maxHeight: '160px'}}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.homeAddress, value);
                                            updateFormFieldMsg(mf.homeAddress, '');
                                            panelLog('');
                                        }}
                                    />

                                    {/*memberRemark*/}
                                    <ThemedInput
                                        wrapperClassName={''}
                                        className={''}
                                        label={mf.memberRemark.title}
                                        placeholder={mf.memberRemark.title}
                                        id={mf.memberRemark.column}
                                        value={getFormField(mf.memberRemark)}
                                        msg={getFormFieldMsg(mf.memberRemark)}
                                        asTextArea={true}
                                        style={{minHeight: '60px', height: '80px', maxHeight: '160px'}}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            updateFormField(mf.memberRemark, value);
                                            updateFormFieldMsg(mf.memberRemark, '');
                                            panelLog('');
                                        }}
                                    />
                                </div>
                            )}
                        </GridBox>
                    </ExpandableView>
                </div>
            </FormPageRoot>
        </>
    )

    function handleSubmit() {
        const fun = 'handleSubmit:';
        log(fun, 'formData:', formData);
        log(fun, 'UnderMaintenance:', UnderMaintenance);
        if (UnderMaintenance) {
            toast(UnderMaintenanceMsg, CssVariant.warning);
            return false;
        }
        if (!isOnline) {
            toast(internetCheckingMsg, CssVariant.warning);
            return false;
        }

        try {
            let allFieldsChecked = checkRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);
                panelLog(null);

                const REQUEST_OPTIONS = {
                    updateOnly: isUpdateMode(),
                    recordId: getField(Fields.updateRecordId),
                    formData: formData,
                };
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__member_addEditPage_submit_formData,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false);//for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                                redirectPage();
                            } else {
                                createTimeout(() => {
                                    clearPanelData();
                                }, 300);
                            }
                            if (onSuccess) onSuccess();
                        } else {
                            toast(message, CssVariant.danger);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        toast(Messages.saveError, CssVariant.danger);
                        updateField(Fields.submitBtn_AsLoading, false);
                        updateField(Fields.submitBtn_disabled, false);
                        logErr(fun, error);
                    }),
                });
            }
        } catch (error) {
            toast(Messages.saveError, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            logErr(fun, error);
        }
    }

    async function fetchCompanies(checkBefore = true) {
        const fun = 'fetchCompanies:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isCompDataFetched))) {
            updateField(Fields.isCompDataFetched, true);
            updateField(Fields.showCompaniesLoading, true);
            updateField(Fields.companies, []);
            updateFormField(mf.companyId, null);
            updateFormField(mf.companyName, null);
            try {
                //send-request
                const REQUEST_OPTIONS = {};
                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__company__mainPage_fetch_recordList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        // log(fun, 'fetchedData:', fetchedData);
                        let comps = getJsonValue(fetchedData, 'data', []);
                        const success = checkNullArr(comps);
                        if (success) {
                            //format list
                            const mf_comp = AdminModuleFieldsData[AdminModules.Company];
                            comps = comps.map((item) => {
                                return {
                                    id: getJsonValue(item, mf_comp.recordId.title),
                                    text: getJsonValue(item, mf_comp.companyName.title),
                                };
                            }).filter(item => checkNullJson(item));
                            // log(fun, 'fetchedData.comps:', comps);

                            updateField(Fields.companies, comps);
                        } else {
                            toast("No companies found!", CssVariant.danger);
                        }
                        updateField(Fields.showCompaniesLoading, false);
                    }),
                    onError: ((error) => {
                        toast("Couldn't load companies, please try again!", CssVariant.danger);
                        updateField(Fields.showCompaniesLoading, false);
                        logErr(fun, error);
                    }),
                });
            } catch (error) {
                toast("Couldn't load companies, please try again!", CssVariant.danger);
                updateField(Fields.showCompaniesLoading, false);
                logErr(fun, error);
            }
        }
    }

    async function fetchCurrCompanyGroups(companyId, companyName, checkBefore = true) {
        const fun = 'fetchCurrCompanyGroups:';
        if (checkNullStr(companyId)) {
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isCurrCompGroupsFetched))) {
                updateField(Fields.showCurrCompGroupsLoading, true);
                updateField(Fields.isCurrCompGroupsFetched, true);
                updateField(Fields.currCompGroups, []);
                updateFormField(mf.assignGroupId, null);
                updateFormField(mf.assignGroupName, null);
                try {
                    //send-request
                    const REQUEST_OPTIONS = {companyId};
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.fetchCompanyGroups,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);
                            let groups = getJsonValue(fetchedData, 'data', []);
                            const success = checkNullArr(groups);
                            if (success) {
                                //format list
                                groups = groups.map((item) => {
                                    return {
                                        id: getJsonValue(item, 'id'),
                                        text: getJsonValue(item, 'name'),
                                    };
                                }).filter(item => checkNullJson(item));
                                log(fun, 'fetchedData.groups:', groups);

                                updateField(Fields.currCompGroups, groups);
                                // toast(`Found ${groups.length} ${groups.length > 1 ? 'groups' : 'group'} for '${companyName}' company!`, CssVariant.info);
                            } else {
                                toast(`No groups found for '${companyName}' company!`, CssVariant.info);
                            }
                            updateField(Fields.showCurrCompGroupsLoading, false);
                        }),
                        onError: ((error) => {
                            toast(`Couldn't load groups for '${companyName}' company, please try again!`, CssVariant.danger);
                            updateField(Fields.showCurrCompGroupsLoading, false);
                            logErr(fun, error);
                        }),
                    });
                } catch (error) {
                    toast(`Couldn't load groups for '${companyName}' company, please try again!`, CssVariant.danger);
                    updateField(Fields.showCurrCompGroupsLoading, false);
                    logErr(fun, error);
                }
            }
        } else {
            toast("Please select a company first!", CssVariant.warning);
        }
    }

    async function fetchEditModeData(recordId, checkBefore = true) {
        const fun = 'fetchEditModeData:';
        try {
            // log(fun, 'recordId:', recordId, 'isUpdateFormDataFetched:', isFieldTrue(Fields.isUpdateFormDataFetched));
            if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isUpdateFormDataFetched))) {
                updateField(Fields.isUpdateFormDataFetched, true);
                updateField(Fields.updateRecordId, recordId);
                if (checkNullStr(recordId)) {
                    updateField(Fields.isDataLoading, true);
                    updateField(Fields.dataLoadingMsg, "");
                    setFormData({});
                    setFormFieldsMsgs({});

                    //send-request
                    const REQUEST_OPTIONS = {
                        recordId: recordId,
                    };
                    sendAdminRequest({
                        reqUrl: AdminReqUrls.admin__member_fetchEditPageRecord,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: (async (fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const fetchedFormData = getJsonValue(fetchedData, 'data', {});
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.isDataFound, success);
                            if (success) {
                                //modify the date-formats of memberDob date otherwise date-inputs won't show the dates
                                const memberDob = getJsonValue(fetchedFormData, mf.memberDob.column);//2024-07-16T18:30:00.000Z
                                const memberDobFormatted = formatDateToIoString(memberDob, 0, 10);//2024-07-16
                                fetchedFormData[mf.memberDob.column] = memberDobFormatted;
                                log(fun, 'memberDob:', memberDob, 'memberDobFormatted:', memberDobFormatted);

                                log(fun, 'isCloneMode:', isCloneMode());
                                if (isCloneMode()) {
                                    //Remove p/w on clone-mode
                                    fetchedFormData[mf.userPassword.column] = '';
                                    fetchedFormData[mf.vokUserPassword.column] = '';
                                    fetchedFormData[mf.loginPin.column] = '';
                                    fetchedFormData[mf.firstName.column] = '';
                                    fetchedFormData[mf.lastName.column] = '';
                                    fetchedFormData[mf.fullName.column] = '';
                                    fetchedFormData[mf.username.column] = '';
                                    fetchedFormData[mf.memberEmail1.column] = '';
                                    fetchedFormData[mf.memberEmail2.column] = '';
                                    fetchedFormData[mf.memberMobile1.column] = '';
                                    fetchedFormData[mf.memberMobile2.column] = '';
                                    fetchedFormData[mf.homePhone.column] = '';
                                }
                                setFormData(fetchedFormData);

                                const companyId = getJsonValue(fetchedFormData, mf.companyId.column);
                                const companyName = getJsonValue(fetchedFormData, mf.companyName.column);
                                await fetchCurrCompanyGroups(companyId, companyName, false);

                                //Update group-data
                                const groupId = getJsonValue(fetchedFormData, mf.assignGroupId.column);
                                const groupName = getJsonValue(fetchedFormData, mf.assignGroupName.column);
                                log(fun, 'fetchedFormData.groupId:', groupId, 'groupName:', groupName);
                                updateFormField(mf.assignGroupId, groupId);
                                updateFormField(mf.assignGroupName, groupName);
                            } else {
                                toast(message, CssVariant.danger);
                                updateField(Fields.dataLoadingMsg, "Invalid record id!");
                            }
                            updateField(Fields.isDataLoading, false);
                        }),
                        onError: ((error) => {
                            logErr(fun, error);
                            updateField(Fields.dataLoadingMsg, Messages.fetchError);
                            updateField(Fields.isDataFound, false);
                            updateField(Fields.isDataLoading, false);
                        }),
                    });
                } else {
                    updateField(Fields.dataLoadingMsg, 'Record-id not found!');
                    updateField(Fields.isDataFound, false);
                    updateField(Fields.isDataLoading, false);
                }
            }
        } catch (error) {
            logErr(fun, error);
            updateField(Fields.dataLoadingMsg, Messages.fetchError);
            updateField(Fields.isDataFound, false);
            updateField(Fields.isDataLoading, false);
        }
    }

    function redirectPage() {
        createTimeout(() => {
            panelLog(`Redirecting you to the '${moduleName}' page now...`);
            createTimeout(() => {
                // window.location.href = AdminModuleRouteUrls[moduleName];
                navigate(AdminModuleRouteUrls[moduleName]);
            }, 2500);
        }, 500);
    }

    function checkRequiredFields() {
        const fun = 'checkRequiredFields:';
        const requiredFields = Object.values(SectionRequiredFields).flat();
        if (checkNullArr(getField(Fields.currCompGroups))) {
            // requiredFields.push(mf.assignGroupId);
            requiredFields.splice(1, 0, mf.assignGroupId);//Insert it after companyId
        }
        // log(fun, "requiredFields:", requiredFields);

        let verified = false;
        let colField = {};
        let handleInvalids = true;
        for (const loopField of requiredFields) {
            const fieldValue = formData[loopField.column];
            if (!checkNullStr(fieldValue)) {
                colField = loopField;
                verified = false;
                break;
            } else if (deepObjectComparison(loopField, mf.memberEmail1)) {
                colField = loopField;
                let valid = Patterns.emailStandard.test(fieldValue);
                // log(fun, "email-validation-condition:", colField, 'fieldValue:', fieldValue, 'valid:', valid);
                if (!valid) {
                    verified = false;
                    handleInvalids = false;
                    const colTitle = getDefStr(loopField.titleAlt, loopField.title);
                    expandMatchingSectionByFieldName(colTitle);
                    toast(`'${colTitle}' is invalid!`, CssVariant.danger);
                    updateFormFieldMsg(loopField, 'Invalid email!');
                    focusIdField(loopField.column);
                    break;
                }
            } else {
                verified = true;
            }
        }
        if (!verified && handleInvalids) {
            const colTitle = getDefStr(colField.titleAlt, colField.title);
            expandMatchingSectionByFieldName(colTitle);
            if (deepObjectComparison(colField, mf.assignGroupId)) {
                setSectionsExpanded({[SECTIONS.basicDetails]: true});
            }
            // log(fun, "!verified.colField:", colField, 'idToFocus:', colField.column);
            updateFormFieldMsg(colField, 'Required field');
            toast(`'${colTitle}' cannot be empty!`, CssVariant.danger);
            focusIdField(colField.column);
        }
        return verified;
    }

    /**
     * Focus the expandable-section that contains the specified field name based on {@link SectionRequiredFields}.
     * @param {string} fieldTitle - The name of the field to search for.
     */
    function expandMatchingSectionByFieldName(fieldTitle) {
        const fun = 'expandMatchingSectionByFieldName:';
        // log(fun, 'fieldTitle:', fieldTitle, "sectionsExpanded:", sectionsExpanded);
        try {
            for (const [sectionName, fields] of Object.entries(SectionRequiredFields)) {
                handleSectionExpCollapse(sectionName, false);
                if (checkNullArr(fields) && fields.some(item => (item.title + '').includes(fieldTitle))) {
                    // log(fun, "sectionName:", sectionName);
                    // handleSectionExpCollapse(sectionName, true);
                    setSectionsExpanded({[sectionName]: true});
                    break;
                }
            }
        } catch (error) {
            logErr(fun, error);
        }
    }


    function focusIdField(id, onlyFocus = false) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
    }


    function clearPanelData() {
        setFormFieldsMsgs({});
        setFormData({});
        setFieldsData({});
    }

    function handleSectionExpCollapse(title, expanded) {
        setSectionsExpanded(prevState => ({...prevState, [title]: isBoolTrue(expanded)}));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function updateFormFieldMsg(clmField, value, direct = false) {
        setFormFieldsMsgs(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormFieldMsg(clmField, defValue, direct = false) {
        return getJsonValue(formFieldsMsgs, direct ? clmField : clmField.column, defValue);
    }

    function isUpdateMode() {
        return isBoolTrue(updateOnly);
    }

    function isCloneMode() {
        return isBoolTrue(cloneMode);
    }

    function getTabTitle() {
        // if (isUpdateMode()) return 'Edit Member';
        // else if (isCloneMode()) return 'Clone Member';
        // else return `Add Member`;
        return isCloneMode() ? 'Clone Member' : null;
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

//======================Util Functions end=====================
});
export default Member__AddEditFormPage;


const ExpandableView = React.memo(({
                                       className = '',
                                       title,
                                       children,
                                       expanded = false,
                                       retainInDOM = true,
                                       onToggle,
                                   }) => {
    const TAG = "ExpandableView";
    const theme = useTheme();
    const [isOpen, setIsOpen] = useState(isBoolTrue(expanded));

    const animator = new FramerAnimator();

    useEffect(() => {
        // log('useEffect.expanded:', expanded);
        setIsOpen(isBoolTrue(expanded));
    }, [expanded]);

    const toggleOpen = () => {
        // log('toggleOpen.isOpen:', !isOpen);
        setIsOpen(!isOpen);
        if (onToggle) onToggle(!isOpen);
    };
    return (<div className={`border-1 rounded-4 ${className} ${isOpen ? `border-theme-resp-20` : `border-t`}`}>
        {/*header*/}
        <div className={`px-2x`} onClick={toggleOpen}>
            <div
                className={`text-theme-resp text-wrap fw-semi-bold cursor-pointer px-2 py-1 d-flex jc-between al-center fd-row flex-nowrap transition position-relative ${isOpen ? `highlight-dark-light highlight-dark-high-hover highlight-dark-high-active rounded-top-3` : `bg-dark-05 highlight-dark-light-hover highlight-dark-active rounded-3`}`}
            >
                <div className={'text-wrap'}>{title}</div>

                <ThemedIconButton
                    className={'mx-2 p-2'}
                    icon={`${isOpen ? IconClass.angleUp : IconClass.angleDown} exp-icon`}
                    tooltip={isOpen ? 'Collapse' : 'Expand'}
                    circular={true}
                    borderWidth={0}
                    outlined={true}
                    color={theme.text70}
                    hoverColor={theme.primaryDark}
                    hoverBgColor={theme.primary20}
                    rippleColor={theme.primary30}
                    size={'24px'}
                    iconSize={FsVarVariant.LG}
                    onClick={toggleOpen}
                />
            </div>
        </div>

        {/*children*/}
        {isBoolTrue(retainInDOM)
            ? animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(150).setDuration(300).render(
                <div className={`px-3 py-1`}
                     style={{
                         display: isOpen ? 'block' : 'none',
                     }}>
                    {children}
                </div>)
            : (isOpen) && animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(150).setDuration(300).render(
            <div className={`px-3 py-1`}>
                {children}
            </div>)
        }
    </div>)

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
